export function journalMap(
    date: string,
    idm: string,
    inventoryAccount: string,
    coexAccount: string,
    stockIn: number,
    stockOut: number,
    amount: number
  ) {

    if (Number(stockOut)) {
      return [
        {
          date,
          idm,
          account: inventoryAccount,
          debet: 0,
          credit: amount
        },
        {
          date,
          idm,
          account: coexAccount,
          debet: amount,
          credit: 0
        }
      ];
    }
    
    if (Number(stockIn)) {
      return [
        {
          date,
          idm,
          account: inventoryAccount,
          debet: amount,
          credit: 0
        },
        {
          date,
          idm,
          account: coexAccount,
          debet: 0,
          credit: amount
        }
      ];
    }
  
    return [];
  }
  